<form
  class="form-horizontal"
  autocomplete="off"
  #resetPasswordForm="ngForm"
  (ngSubmit)="changePassword()"
>
  <abp-modal-header
    [title]="'UpdatePassword' | localize"
    (onCloseClick)="bsModalRef.hide()"
  ></abp-modal-header>
  <div class="modal-body">
    <label for="newPassword">
      {{ "CpfCnpj" | localize }}
    </label>
    <div class="form-group row">
      <div class="input-group col-12">
        <input
          type="text"
          class="form-control"
          id="cpfAddress"
          name="cpfAddress"
          disabled
          [value]="cpfCnpjExibicao"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-user"></span>
          </div>
        </div>
      </div>
    </div>
    <label class="required" for="newPassword">
      {{ "NewPassword" | localize }}
    </label>
    <div class="form-group row">
      <div class="input-group col-12">
        <input
          [type]="showPassword ? 'password':'text'"
          class="form-control"
          name="newPassword"
          id="newPassword"
          required
          minlength="2"
          maxlength="32"
          validateEqual="confirmNewPassword"
          reverse="true"
          pattern="(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!.@#$%^&*()]*$"
          [(ngModel)]="model.newPassword"
          #newPasswordModel="ngModel"
          #newPasswordEl
        />
        <div class="input-group-append">
          <div class="input-group-text p-3" style="cursor: pointer;" (click)="visualizarSenha('showPassword')">
            <span class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
          </div>
        </div>
      </div>
      <abp-validation-summary class="col-12"
        [control]="newPasswordModel"
        [controlEl]="newPasswordEl"
        [customValidationErrors]="newPasswordValidationErrors"
      ></abp-validation-summary>
    </div>
    <label for="confirmNewPassword">
      {{ "ConfirmNewPassword" | localize }}
    </label>
    <div class="form-group row">
      <div class="input-group col-12">
        <input
        [type]="newPassword ? 'password':'text'"
          class="form-control"
          name="confirmNewPassword"
          id="confirmNewPassword"
          required
          minlength="2"
          maxlength="32"
          validateEqual="newPassword"
          reverse="false"
          ngModel
          #confirmNewPasswordModel="ngModel"
          #confirmNewPasswordEl
        />
        <div class="input-group-append">
          <div class="input-group-text p-3" style="cursor: pointer;" (click)="visualizarSenha('newPassword')">
            <span class="fas" [ngClass]="newPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
          </div>
        </div>
      </div>
      <abp-validation-summary class="col-12"
        [control]="confirmNewPasswordModel"
        [controlEl]="confirmNewPasswordEl"
        [customValidationErrors]="confirmNewPasswordValidationErrors"
      ></abp-validation-summary>
    </div>
  </div>
<abp-modal-footer
    [cancelDisabled]="saving"
    [saveDisabled]="!resetPasswordForm.form.valid || saving"
    (onCancelClick)="bsModalRef.hide()"
    saveLabel="Alterar"
  ></abp-modal-footer>
</form>
